import {
  GET_ADMIN_FILTER_PACKAGES,
  GET_ADMIN_FILTER_PACKAGES_SUCCESS,
  GET_ADMIN_FILTER_PACKAGES_ERROR,
  POST_ADMIN_FILTER_PACKAGES,
  POST_ADMIN_FILTER_PACKAGES_SUCCESS,
  POST_ADMIN_FILTER_PACKAGES_ERROR,
  UPDATE_ADMIN_FILTER_PACKAGES,
  UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS,
  UPDATE_ADMIN_FILTER_PACKAGES_ERROR,
  DELETE_ADMIN_FILTER_PACKAGES,
  DELETE_ADMIN_FILTER_PACKAGES_SUCCESS,
  DELETE_ADMIN_FILTER_PACKAGES_ERROR,
} from "./actionTypes"

export const getAdminFilterPackages = () => ({
  type: GET_ADMIN_FILTER_PACKAGES,
})

export const getAdminFilterPackagesSuccess = (payload) => ({
  type: GET_ADMIN_FILTER_PACKAGES_SUCCESS,
  payload: payload
})

export const getAdminFilterPackagesError = (error) => ({
  type: GET_ADMIN_FILTER_PACKAGES_ERROR,
  payload: error
})

export const createAdminFilterPackages = (payload) => ({
  type: POST_ADMIN_FILTER_PACKAGES,
  payload: payload
})

export const createAdminFilterPackagesSuccess = (payload) => ({
  type: POST_ADMIN_FILTER_PACKAGES_SUCCESS,
  payload: payload
})

export const createAdminFilterPackagesError = (error) => ({
  type: POST_ADMIN_FILTER_PACKAGES_ERROR,
  payload: error
})

export const updateAdminFilterPackages = (payload) => ({
  type: UPDATE_ADMIN_FILTER_PACKAGES,
  payload: payload
})

export const updateAdminFilterPackagesSuccess = (payload) => ({
  type: UPDATE_ADMIN_FILTER_PACKAGES_SUCCESS,
  payload: payload
})

export const updateAdminFilterPackagesError = (error) => ({
  type: UPDATE_ADMIN_FILTER_PACKAGES_ERROR,
  payload: error
})

export const deleteAdminFilterPackages = (payload) => ({
  type: DELETE_ADMIN_FILTER_PACKAGES,
  payload: payload
})

export const deleteAdminFilterPackagesSuccess = (payload) => ({
  type: DELETE_ADMIN_FILTER_PACKAGES_SUCCESS,
  payload: payload
})

export const deleteAdminFilterPackagesError = (error) => ({
  type: DELETE_ADMIN_FILTER_PACKAGES_ERROR,
  payload: error
})